import React, { lazy, Suspense } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';

const LoadableRedux = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "adopts_buyer_shared" */
        '../redux/BuyerModuleLoader'
      )
  )
);

const LoadableModal = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "adopts_buyer_shared" */
        './OrderOriginalDeviationModal'
      )
  )
);

interface Props {
  deviation: PapiDeviation;
  onRequestClose: () => void;
}

const OrderOriginalDeviationModalLoadable: React.FC<Props> = props => (
  <ErrorBoundary debugComponent="OrderOriginalDeviationModalLoadable">
    <Suspense
      fallback={<LoadingIndicator view={'llama'} withOverlay usePortal />}
    >
      <LoadableRedux />
      <LoadableModal {...props} />
    </Suspense>
  </ErrorBoundary>
);
OrderOriginalDeviationModalLoadable.displayName =
  'OrderOriginalDeviationModalLoadable';

export default OrderOriginalDeviationModalLoadable;
